const OldSystemFrame = () => import('@/views/OldSystemFrame');

export default [
  {
    path: 'bkf',
    component: {
      render (c) { return c('router-view') }
    },
    children: [
      {
        path: 'certification',
        component: OldSystemFrame,
        props:{
          url: '/login/templates/content.php?id=182'
        }
      },
    ]
  },
]
